var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-box',{attrs:{"container":"","p":"6"}},[_c('v-data-table',{attrs:{"paginated":"","title":("Tous les SFD du produit " + (_vm.getCurrentProduct.name)),"columns":_vm.columns,"items":_vm.items,"hide-add-action":""}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }